const ENV = window.location.host.includes('localhost') ? 'localss' : 'prod';

export const BASE_URL = ENV === 'local' ? 'http://localhost:3001' : 'https://2x190vwi57.execute-api.eu-west-1.amazonaws.com/v1'
